import { Raycaster, Vector3 } from "three";
import { eventToPixel } from "./utilities";

export class RayCaster {
  private initialized = false;
  private width;
  private height;
  private event;
  public camera;
  private raycaster;

  constructor(object, event) {
    const {width, height, camera} = object;

    this.width = width;
    this.height = height;
    this.camera = camera;
    this.event = event;

    this.init();
  }

  init() {
    let direction = this.vectorFromEvent(this.event);
    let raycaster = this.defaultRaycaster(direction);
    this.raycaster = raycaster;
  }

  setPrecision(precision) {
    if (!this.initialized) {
      return;
    }

    this.raycaster.params = {
      'Points': {threshold: precision},
      'Line': {threshold: precision}
    };
  }

  intersectPlane(target) {
    let intersect = new Vector3();
    this.raycaster.ray.intersectPlane(target, intersect);
    return intersect;
  }

  intersectObject(target) {
    return this.raycaster.intersectObject(target);
  }

  intersectTriangle(P1, P2, P3) {
    const result = new Vector3();
    this.raycaster.ray.intersectTriangle(P1, P2, P3, false, result);
    return result.length() > 0 ? result : null;
  }

  intersectObjects(targets, opts={}) {
    if (!this.initialized) {
      return [];
    }

    let defaults = {
      minDistance: null,
      sortByRay: false,
      recursive: true
    };

    let options = {...defaults, ...opts};

    let objects =  this.raycaster.intersectObjects(
      targets, options.recursive);

    if (options.minDistance) {
      objects = objects.filter(item => {
        return item.distance > options.minDistance;
      });
    }

    if (options.sortByRay) {
      objects.sort(function(a, b) {
        return a.distanceToRay - b.distanceToRay;
      });
    }

    return objects;
  }

  vectorFromEvent(event) {
    let uv = eventToPixel(event);
    uv.x = 2 * (uv.x / this.width) - 1;
    uv.y = 1 - 2 * (uv.y / this.height);
    uv.z = 0.5;

    let direction = this.raycastDirection(uv);
    return direction;
  }

  raycastDirection(vector: Vector3) {
    vector.unproject(this.camera);
    vector.sub(this.camera.position).normalize();
    return vector;
  }

  defaultRaycaster(direction) {
    if (!direction) {
      return false;
    }

    let raycaster = new Raycaster();
    let origin = this.camera.position;
    raycaster.set(origin, direction);
    this.initialized = true;
    return raycaster;
  }
}
